// Get environment variables in a way that works in both Node.js and browser
// vite-plugin-runtime-env injects runtime values into window.env
export const getEnvVar = (key) => {
    // 1. Runtime env vars (Docker) - vite-plugin-runtime-env injects into window.env
    if (typeof window !== 'undefined' && window.env?.[key]) {
        return window.env[key];
    }
    // 2. Build-time env vars (Vite dev mode) - use globalThis to avoid TypeScript issues
    if (typeof globalThis !== 'undefined' && globalThis.import?.meta?.env) {
        const value = globalThis.import.meta.env[key];
        if (value !== undefined) {
            return value;
        }
    }
    // Direct access to import.meta.env in Vite environment
    try {
        // @ts-ignore - import.meta is available in Vite
        if (import.meta?.env) {
            // @ts-ignore
            const value = import.meta.env[key];
            if (value !== undefined) {
                return value;
            }
        }
    }
    catch (e) {
        // Fallback if import.meta is not available
    }
    // 3. Node.js
    if (typeof process !== 'undefined' && process.env) {
        const value = process.env[key];
        if (value !== undefined) {
            return value;
        }
    }
    return undefined;
};
